export const initialState = {
    is_loading: true,
    total_ftms: 0,
    total_pages: 0,
    page_number: 1,
    list: [],
    search_type: "",
    sort_key: '',
    sort_direction: '',
    is_show_date_filter: false,
    serach_text: '',
    start_date: '',
    end_date: '',
    error: null,
}